/** * サンプルコンポーネント(コンポーネント動作検証等に使用) */
<template>
  <div id="the-sample">
    <p>{{ time }}</p>
    <p>{{ timezone }}</p>
    <p>{{ local }}</p>
    <p>{{ server }}</p>
  </div>
</template>

<script>
import { getLocalTimezone, toLocalTz, toServerTz } from '@/js/TimezoneHelper'

export default {
  name: 'TheSample',
  setup() {
    return { timezone: getLocalTimezone() }
  },
  data: function () {
    return {
      time: '2024-02-03T16:32:43',
      local: null,
      server: null,
    }
  },
  mounted: function () {
    this.local = toLocalTz(this.time)
    this.server = toServerTz(this.time)
  },
}
</script>

<style lang="scss" scoped>
#the-sample {
  height: calc(100% - #{$navigation-bar-height});
  width: 100%;
  padding-top: $navigation-bar-height;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.wrapper {
  width: 600px;
  height: 400px;
  background-color: #eeeeee;
  overflow: hidden;
  position: relative;
}

.content {
  width: 200px;
  background-color: #ffcccc;
}
</style>
